import { Bot } from "lucide-react";
import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { APP_VERSION_INFO } from "~/constants";
import { useBotNameAndVersion } from "@noa/client-store";
import { Button, Card, Dialog, Divider, Text, Title } from "~/components/ui";

interface AppAboutInfoModalProps {
  open: boolean;
  onClose: () => void;
}

export const AppAboutInfoModal: FunctionComponent<AppAboutInfoModalProps> = ({ open, onClose }) => {
  const { t } = useTranslation();
  const botNameAndVersion = useBotNameAndVersion();

  return (
    <Dialog
      title={t("about:title")}
      open={open}
      onCancel={onClose}
      footer={[
        <Button key="ok" variant="primary" onClick={onClose}>
          {t("common:ok")}
        </Button>,
      ]}
      centered
    >
      <Card className="mt-6 text-center" bodyClassName="p-0">
        <div className="flex justify-center p-5">
          <Bot size={64} className="text-noa-primary" />
        </div>
        <div className="p-6">
          <Title level={3}>{t("about:headertitle")}</Title>
          <Text tone="muted" className="mb-4 block">
            {t("about:description")}
          </Text>

          <Divider />

          <div className="flex w-full flex-col gap-2">
            <div>
              <Text>{t("about:webappRelease")} </Text>
              <Text strong>
                {APP_VERSION_INFO.VERSION_DATE} ({APP_VERSION_INFO.VERSION})
              </Text>
            </div>
            <div>
              <Text>{t("about:botVersion")} </Text>
              <Text strong>{botNameAndVersion || t("about:notConnected")}</Text>
            </div>
          </div>
        </div>
      </Card>
    </Dialog>
  );
};
